import { sessionConfig } from 'utils/constant';
import { v4 as uuidv4 } from 'uuid';
import QueryString from 'qs';
import { getAccessToken, axios } from 'utils/common';

class RealtimeMapService {
  getSnapToRoads({ query }) {
    // const Cryptr = require('cryptr')
    // const cryptr = new Cryptr(getAccessToken)
    // const encryptedWorkCertString = cryptr.encrypt(projid)
    // const decryptedWorkCertString = cryptr.decrypt(encryptedWorkCertString)
    //
    //

    const stringifiedQuery = query?.join('|');

    return axios({
      method: 'get',
      url: `https://roads.googleapis.com/v1/snapToRoads?path=${stringifiedQuery}&key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}`
    });
  }
  getGpsGroupByInterval(params) {
    const { projId, data } = params;
    // const Cryptr = require('cryptr')
    // const cryptr = new Cryptr(getAccessToken)
    // const encryptedWorkCertString = cryptr.encrypt(projid)
    // const decryptedWorkCertString = cryptr.decrypt(encryptedWorkCertString)
    //
    //
    const URL = `Gps/${projId}/Proj`;

    return axios({
      method: 'post',
      url: URL,
      data,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }
  getBatchLocationInterval(params) {
    const { projId, reftype = 'RFID', refid } = params;
    // const Cryptr = require('cryptr')
    // const cryptr = new Cryptr(getAccessToken)
    // const encryptedWorkCertString = cryptr.encrypt(projId)
    // const decryptedWorkCertString = cryptr.decrypt(encryptedWorkCertString)
    //
    //
    const URL = `Gps/${projId}/${reftype}/${refid}/Route`;

    return axios({
      method: 'post',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }

  getDeviceLocationHistories(deviceId) {
    const URL = `Gps/${deviceId}/Device`;
    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }
  getGpsHistories(deviceId) {
    const URL = `Gps/${deviceId}/Device/status/time`;
    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }
  getTVehicleGpsHistories(params) {
    const { batchNo = '', rfidmoduleId } = params;

    const URL = `Gps/${batchNo}/Batch/status/time`;
    return axios({
      method: 'get',
      params: { rfidmoduleId },
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }
  getVehicles(params) {
    const { projid = '' } = params;
    const URL = `Masters/${projid}/Vehicles/List`;
    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }
  getTVehicles(params) {
    const { projid = '' } = params;
    const URL = `Masters/${projid}/Batch/List`;
    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }
}

export const realtimeMapService = new RealtimeMapService();
